<template>
    <ul class="list-group hidden-xs slider-param">
        <li><h4>Cenová kategória</h4></li>
        <!-- <li v-bind:class="{ 'active' : prices.selected === null }"><a @click="prices.selected = null">Všetky ceny<span class="label-in pull-right"><p>{{ products.length }}</p></span></a></li> -->
        <li>
            <div id="price_slider"></div>
            <div class="range-price">
                <span>0 €</span>
                <span class="pull-right">{{ maxPrice }} €</span>
            </div>
        </li>
    </ul>
</template>

<script>
    export default {
        props : ['prices', 'category', 'products'],

        mounted(){
            this.bindRange();
        },

        watch: {
            prices(items){
                console.log(items);
            },
        },

        computed: {
            maxPrice(){
                var sortedProducts = _.maxBy(_.cloneDeep(this.products), function(item){
                        return parseFloat(item.price);
                    }),
                    maxPrice = parseInt(sortedProducts ? sortedProducts.price : 0) + 1;

                if ( this.slider )
                {
                    this.slider.updateOptions({
                        range : {
                            'min': 0,
                            'max': maxPrice,
                        }
                    });

                    if ( ! this.prices.selected )
                        this.slider.updateOptions({
                            start: [0, maxPrice],
                        });

                }

                return maxPrice;
            }
        },

        methods: {
            priceFormat(key, price){
                if ( !(key + 1 in this.prices.filter) )
                    return price + '€ +';

                var to = this.prices.filter[key + 1];

                return price + '€ - ' + ( to - 0.01 ) + '€';
            },
            /*
             * Count all products in price interval
             */
            productsInPriceCategory(key){
                return this.$parent.filterByPrice(this.products, key).length;
            },
            bindRange(){
                this.slider = noUiSlider.create($('#price_slider')[0], {
                    start: [0, this.maxPrice],
                    connect: true,
                    tooltips: true,
                    range: {
                        'min': 0,
                        'max': this.maxPrice,
                    }
                });

                this.slider.on('end', function(e){
                    this.prices.selected = e;
                }.bind(this));
            }
        }
    }
</script>
